import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell, { GoogleButton, MicrosoftButton } from "@/components/auth/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { apiError, track } from "@/lib/api";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { document.title = "Sign in | NetLift"; }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      track("login_completed");
      navigate("/app/dashboard");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Sign in to NetLift"
      subtitle="Welcome back. Pick up where you left off."
      footer={<>New to NetLift? <Link to="/signup" className="font-medium text-navy hover:underline">Create an account</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        {error && <div className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">{error}</div>}
        <div>
          <Label htmlFor="email">Work email</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
        </div>
        <div>
          <div className="flex items-center justify-between">
            <Label htmlFor="password">Password</Label>
            <Link to="/forgot-password" className="text-xs text-slate-500 hover:text-navy">Forgot password?</Link>
          </div>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        </div>
        <Button type="submit" disabled={loading} className="w-full bg-editorial hover:bg-editorial/90" data-testid="login-submit">
          {loading ? "Signing in..." : "Sign in"}
        </Button>
      </form>
      <div className="my-5 flex items-center gap-3 text-xs text-slate-400">
        <span className="h-px flex-1 bg-slate-200" /> or <span className="h-px flex-1 bg-slate-200" />
      </div>
      <GoogleButton label="Sign in with Google" />
      <div className="mt-3">
        <MicrosoftButton label="Sign in with Microsoft" />
      </div>
    </AuthShell>
  );
}
